import React, { useEffect, useState } from "react";
import "./QOP.css";
import { Subidebarc } from "../../../../components/sidebar/Politics/Subsidebar";
import axios from "axios";
import { Loader } from "../../../../components/Loader/Loader";
// const tableData = [
//   {
//     id: 1,
//     sno: 103,
//     qno: 2566,
//     date: "UNSTARRED",
//     qtype: "17.03.2022",
//     ministry: "CIVIL AVIATION",
//     subject: "Krishi UDAN 2.0 Scheme in Odisha",
//   },
//   {
//     id: 2,
//     sno: "",
//     qno: "",
//     date: "",
//     qtype: "",
//     ministry: "",
//     subject: "",
//   },
//   {
//     id: 2,
//     sno: "",
//     qno: "",
//     date: "",
//     qtype: "",
//     ministry: "",
//     subject: "",
//   },

//   {
//     id: 2,
//     sno: "",
//     qno: "",
//     date: "",
//     qtype: "",
//     ministry: "",
//     subject: "",
//   },

//   {
//     id: 2,
//     sno: "",
//     qno: "",
//     date: "",
//     qtype: "",
//     ministry: "",
//     subject: "",
//   },

//   {
//     id: 2,
//     sno: "",
//     qno: "",
//     date: "",
//     qtype: "",
//     ministry: "",
//     subject: "",
//   },
// ];

  

export const QOP = () => {

  const baseUrl = "https://node.acementorpro.com/api/parliamentQuestion";


  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    try {
      const getData = async () => {
        const res = await axios.get(baseUrl);

        setTableData(res.data);
      };
      getData();
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <div className="tns">
      <div className="tns-left">
        <Subidebarc />
      </div>

      <div className="tns-right">
        <div className="tns-heading">
          <span>Question on Parliament</span>
        </div>
        <div className="qop-table">
          <table>
            <tr>
              <th>Serial Number</th>
              <th>Q. NO.</th>
              <th>Date</th>
              <th>Q.Type</th>
              <th>Ministry</th>
              <th>Subject</th>
            </tr>

            {
              !tableData? (<Loader/>) : (<>
                
                {tableData?.map((data, index) => (
                  <tr key={data?._id}>
                    <td> {index+1}</td>
                    <td>{data?.qNo}</td>
                    <td>{new Date(data?.date).toDateString()}</td>
                    <td>{data?.qType}</td>
                    <td>{data?.ministry}</td>
                    <td>{data?.subject}</td>
                  </tr>
                ))}
                
                </>)
            }


          </table>
        </div>
      </div>
    </div>
  );
};
